<script>
    import { format } from "svelte-i18n";

    let { findingSeverityAge = {} } = $props();

    let severities = ["critical", "high", "medium", "low"];
    let totals = {};

    // init totals
    for (const severity of severities) {
        totals[severity] = {
            91: 0,
            61: 0,
            31: 0,
            8: 0,
            0: 0,
        };
    }

    totals["ip"] = {
        91: 0,
        61: 0,
        31: 0,
        8: 0,
        0: 0,
    };

    const days = {
        lessThan7: "< 7",
        lessThan30: "< 30",
        lessThan60: "< 60",
        lessThan90: "< 90",
        moreThan90: "> 90",
    };

    // Mapeo del día mínimo (piso) de cada rango de la tabla
    const bucketMinimumDays = {
        "< 7": 0,
        "< 30": 8,
        "< 60": 31,
        "< 90": 61,
        "> 90": 91,
    };

    const getRequestToFindings = (age, severity) => {
        let days_amount = age.includes("<")
            ? age.replace("< ", "")
            : age.replace("> ", "");
        let startDate = new Date();
        startDate.setDate(startDate.getDate() - days_amount);
        startDate = startDate.toISOString().split("T")[0];

        const setEndDate = (diff) => {
            let endDate = new Date();
            endDate.setDate(endDate.getDate() - diff);
            return (endDate = endDate.toISOString().split("T")[0]);
        };

        let today = new Date();
        today = today.toISOString().split("T")[0];

        const dates = {
            "< 7": `first_discovery_at__gte=${startDate}&first_discovery_at__lte=${today}T23:59:59.999-03:00`,
            "< 30": `first_discovery_at__lte=${setEndDate(8)}T23:59:59.999-03:00&first_discovery_at__gte=${startDate}T00:00:00.000-03:00`,
            "< 60": `first_discovery_at__lte=${setEndDate(31)}T23:59:59.999-03:00&first_discovery_at__gte=${startDate}T00:00:00.000-03:00`,
            "< 90": `first_discovery_at__lte=${setEndDate(61)}T23:59:59.999-03:00&first_discovery_at__gte=${startDate}T00:00:00.000-03:00`,
            "> 90": `first_discovery_at__lte=${startDate}&first_discovery_at__gte=2021-01-28T00:00:00.000-03:00`,
        };
        return `status__in=open,accepted&vulnerability__level__in=${severity}&${dates[age]}`;
    };
</script>

<table class="table table-borderless table-condensed table-striped">
    <thead>
        <tr>
            <th></th>
            <th class="text-center">90+ {$format("page.dashboard.days")}</th>
            <th class="text-center">61-90 {$format("page.dashboard.days")}</th>
            <th class="text-center">31-60 {$format("page.dashboard.days")}</th>
            <th class="text-center">8-30 {$format("page.dashboard.days")}</th>
            <th class="text-center">0-7 {$format("page.dashboard.days")}</th>
        </tr>
    </thead>
    <tbody>
        {#each severities as severity}
            <tr>
                <td
                    ><div
                        class="cvss-badge cvss-{severity}"
                        style="--mwidth: 100px"
                    >
                        {$format(`vulnerability.severity.${severity}`)}
                    </div></td
                >
                {#each [days.moreThan90, days.lessThan90, days.lessThan60, days.lessThan30, days.lessThan7] as age}
                    <td class="text-center">
                        {#if findingSeverityAge[age][severity] > 0}
                            <a
                                href={`/finding?${getRequestToFindings(age, severity)}`}
                            >
                                {findingSeverityAge[age][severity]}
                            </a>
                        {:else}
                            {findingSeverityAge[age][severity]}
                        {/if}
                    </td>
                {/each}
            </tr>
        {/each}
    </tbody>
</table>

<style>
    .cvss-badge {
        width: 10em;
        padding: 3px 20px;
        border-radius: 0.4em;
        text-align: center;
        color: #fff;
        font-size: 0.85em;
        font-weight: bold;
        text-transform: capitalize;
    }
    .is_bold {
        font-weight: 900;
    }
    a {
        color: inherit !important;
        text-decoration: underline;
    }
</style>
